import type { VNodeRef } from 'vue';

import { ref, watch } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

const defSidebars = {
  main: false,
  quote: false,
  reports: false,
  sms: false,
  helpcenter: false,
};

export const useSidebarsStore = defineStore('sidebars', () => {
  const sidebars = ref(_cloneDeep(defSidebars));

  // https://pinia.vuejs.org/cookbook/composables.html#Setup-Stores
  const _rootRef = ref<VNodeRef | null>(null);

  function $reset(): void {
    sidebars.value = _cloneDeep(defSidebars);
  }

  function setRootElement(element: VNodeRef | null): void {
    _rootRef.value = element;
  }

  watch(
    () => sidebars.value.main,
    (newValue, oldValue) => {
      if (newValue && !oldValue) {
        sidebars.value.helpcenter = false;
      }
    },
  );

  watch(
    () => sidebars.value.quote,
    (newValue, oldValue) => {
      if (newValue && !oldValue) {
        sidebars.value.reports = false;
        sidebars.value.sms = false;
        _rootRef.value?.querySelector('[data-drawer=quote] .v-list').focus(); // HACK find the way to pass the element not from a data attribute
      }
    },
  );

  watch(
    () => sidebars.value.reports,
    (newValue, oldValue) => {
      if (newValue && !oldValue) {
        sidebars.value.quote = false;
        sidebars.value.sms = false;
        _rootRef.value?.querySelector('[data-drawer=reports] .v-list').focus(); // HACK find the way to pass the element not from a data attribute
      }
    },
  );

  watch(
    () => sidebars.value.sms,
    (newValue, oldValue) => {
      if (newValue && !oldValue) {
        sidebars.value.quote = false;
        sidebars.value.reports = false;
        _rootRef.value?.querySelector('[data-drawer=sms] .v-list').focus();
      }
    },
  );

  watch(
    () => sidebars.value.helpcenter,
    (newValue, oldValue) => {
      if (newValue && !oldValue) {
        sidebars.value.main = false;
        sidebars.value.quote = false;
        sidebars.value.reports = false;
        sidebars.value.sms = false;
      }
    },
  );

  return {
    sidebars,
    $reset,
    setRootElement,
  };
});
